import BaseMutations from '@/store/base/mutations'
// import * as Types from '@/store/mutationTypes'

// const module = 'comments'

export default BaseMutations({
  //
})